import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  BidvTransferDestWhitelistService,
  BidvTransferDestWhitelistItemEntity,
  CreateBidvTransferDestWhitelistDto,
} from 'services/openapi';

import { BidvBankTransferServiceKeys } from '../queries/constants';

export const useCreateBidvTransferDestWhitelistMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      BidvTransferDestWhitelistItemEntity,
      Error,
      CreateBidvTransferDestWhitelistDto
    >({
      mutationFn: (variables: CreateBidvTransferDestWhitelistDto) =>
        BidvTransferDestWhitelistService.bidvTransferDestWhitelistControllerCreate(
          variables,
        ),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [BidvBankTransferServiceKeys.GET_TRANSFER_DEST_WHITELIST],
        });
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
